import { render, staticRenderFns } from "./reduce.vue?vue&type=template&id=8876315c&scoped=true&"
import script from "./reduce.vue?vue&type=script&lang=js&"
export * from "./reduce.vue?vue&type=script&lang=js&"
import style0 from "./reduce.vue?vue&type=style&index=0&id=8876315c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8876315c",
  null
  
)

export default component.exports